// extracted by mini-css-extract-plugin
export default {"outerSection":"CTA_outerSection__pY2JS","card":"CTA_card__v8gjf","title":"CTA_title__PdLjC","text":"CTA_text__SWw+2","highlight":"CTA_highlight__bUZ7h","button":"CTA_button__MfV2E"};